import * as React from 'react';
import {FunctionComponent} from 'react';
import {PartialWorkout} from '../../../Models/PartialWorkout';
import {DateRange} from '../../../Domain/DateRange';
import {PieChart} from './PieChart';
import {WorkoutExecutionType} from '../../../Models/WorkoutExecutionType';

interface OwnProps {
    partialWorkouts: PartialWorkout[];

    //Grouping will follow the daterange if supplied, otherwise a daterange will be created from the partialworkouts
    dateRange?: DateRange;
}

export const SummaryPieChart: FunctionComponent<OwnProps> = ({partialWorkouts, dateRange}) => {
    const applicableWorkouts = partialWorkouts.filter((partialWorkout) => {
        if (!dateRange) {
            return true;
        }

        return (
            (dateRange.from === null || partialWorkout.executed_at > dateRange.from) &&
            (dateRange.till === null || partialWorkout.executed_at < dateRange.till)
        );
    });

    const parts = applicableWorkouts.reduce(
        (p, applicableWorkout) => {
            const totalTraveledMeters = applicableWorkout.workout_part_results.reduce(
                (totalMeters, workoutPartResult) => totalMeters + workoutPartResult.traveled_distance.meters,
                0,
            );

            switch (applicableWorkout.execution_type) {
                case WorkoutExecutionType.INDOOR:
                    p[0].fraction += totalTraveledMeters;
                    return p;
                case WorkoutExecutionType.OUTDOOR:
                    p[1].fraction += totalTraveledMeters;
                    return p;
            }
        },
        [
            {
                label: 'Indoor',
                fraction: 0,
                color: '#3ac4e7',
            },
            {
                label: 'Outdoor',
                fraction: 0,
                color: 'black',
            },
        ],
    );

    const normalizedParts = parts
        .map((part) => ({
            label: part.label,
            fraction: part.fraction / parts.reduce((total, p) => total + p.fraction, 0),
            color: part.color,
        }))
        .filter((part) => part.fraction > 0);

    if (normalizedParts.length === 0) {
        return null;
    }

    return (
        <PieChart parts={normalizedParts} colorScale={normalizedParts.map((normalizedPart) => normalizedPart.color)} />
    );
};
